<template>
    <div class="bl-filter">
        <div class="pane-header">
          <div>
            <h2>Filters</h2>
            <i>Select the sections you wish to see in isolation.</i>
          </div>
          <font-awesome-icon :icon="['fas', 'times']" size="sm" @click="closeIt"/>
                    
        </div>
        <div class="pane-content container ml-4" v-if="getAllByLaws && getAllByLaws.count > 0" ref="contentList">
            <div v-for="part in getAllByLaws.parts" :key="part.id">
                <div class="part-title mt-2 row" @click="loadPart($event, part.id)">
                  <div>
                    <font-awesome-icon icon="caret-right" class="plus"/>
                    <font-awesome-icon icon="caret-down" class="minus d-none"/> 
                  </div>
                  <div class="col title-text">
                      <b>{{part.title}}</b>
                  </div>
                  
                </div>
                <div class="indent d-none">
                    <div v-for="content in part.children" :key="content.id">
                        <div class="title row"  @click="expand($event)">  
                          <div style="width:10px;">
                            <font-awesome-icon icon="caret-right" class="plus"/>
                            <font-awesome-icon icon="caret-down" class="minus d-none"/>
                             
                          </div>
                          <div class="col title-text">                      
                            {{content.version}} {{content.title}}
                          </div>  
                        </div>
                        <div class="indent d-none">
                            <div v-for="subcontent in content.subDocuments" :key="subcontent.id" >
                                <div class="title row"  @click="expand($event)">
                                  <div style="width:30px;">
                                    <font-awesome-icon icon="caret-right" class="plus" :class="subcontent.subDocuments?'visible':'invisible'"/>
                                    <font-awesome-icon icon="caret-down" class="minus d-none" :class="subcontent.subDocuments?'visible':'invisible'"/> 
                                    <input :value="subcontent" type="checkbox" data-id="subcontent.id" v-model="contentList" @change="checkChildren($event, subcontent.parentID, subcontent.subDocuments)"/> 
                                  </div>
                                  <div class="col title-text">
                                    {{subcontent.version}} {{subcontent.title}}
                                  </div>
                                </div>
                                 <div class="indent d-none">
                                    <div v-for="children in subcontent.subDocuments" :key="children.id" >
                                      <div class="title row" @click="expand($event)">      
                                        <div style="width:30px;">
                                          <font-awesome-icon icon="caret-right" class="plus" :class="children.subDocuments?'visible':'invisible'"/>
                                          <font-awesome-icon icon="caret-down" class="minus d-none" :class="children.subDocuments?'visible':'invisible'"/> 
                                          <input :value="children" type="checkbox" data-id="children.id" v-model="contentList" @change="checkChildren($event,children.parentID, children.subDocuments)"/> 
                                          </div>   
                                          <div class="col title-text">                                   
                                            {{children.version}} {{children.title}}
                                          </div>
                                      </div>  
                                      <div class="indent d-none">
                                      <div v-for="grandchild in children.subDocuments" :key="grandchild.id" >
                                          <div class="title pl-3 row" @click="expand($event)">      
                                            <div style="width:10px;">
                                            <input :value="grandchild" type="checkbox" data-id="grandchild.id" v-model="contentList" @change="checkChildren($event,grandchild.parentID, grandchild.subDocuments)"/> 
                                            </div>   
                                            <div class="col">                                   
                                              {{grandchild.version}} {{grandchild.title}}
                                            </div>
                                          </div>                                        
                                        </div>
                                      </div>                                      
                                    </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
         
            <div class="mb-2 mt-3">
              <div class="card-body text-center" >               
                &nbsp;
              </div>
            </div>
        </div>
        <div class="control">
          <input type="button" class="btn btn-secondary mr-3" value="Cancel" @click="closeIt">
          <input type="button" class="btn btn-primary" value="Apply filters" @click="apply" :disabled="contentList.length==0">
        </div>
    </div>
</template>

<script>

import closeIcon from "@/components/Svg/CloseIcon";
import { mapGetters,mapActions } from "vuex";
import VersionCompare from "@/components/Mixins/VersionComparer";
export default {
  name: "filtercontrol",
  components: { closeIcon},
  data(){
    return{
      contentList:[],
      showPartChildren: false,
      showLevel2: true,
      showLevel3: true
    }
  },
  computed: {
    ...mapGetters("loader",["getRequestLoadStatus"]),
    ...mapGetters("viewer", ["getServiceStatus","getAllByLaws"])
  },
  methods:{    
    ...mapActions("viewer", ["fetchPusblishedContentByPart"]),   
    checkChildren: function(e, parent, items){
      let self = this;
      if(e.currentTarget.checked){
        if(items != null){ // select all descendent
          items.forEach(elem => {
             if(!self.contentList.includes(elem)){
               self.contentList.push(elem);
             }
          });
        }

      } else {
        if(items != null){  // deselect all descendent       
          items.forEach(elem => {
             if(self.contentList.includes(elem)){
               self.contentList.splice(self.contentList.indexOf(elem),1);
             }
          });
        }
        
        let parentIndex = self.contentList.findIndex(x=>x.id == parent);
        if(parentIndex >= 0){
          self.contentList.splice(parentIndex,1);
        }
        
      }
    },
    loadPart: function(event, id){
      let { target } = event; 
      
      this.fetchPusblishedContentByPart(id);
      while(!target.classList.contains("part-title")){
        target = target.parentNode;
      }
      if(target.nextElementSibling?.classList.contains("d-none")){
        target.nextElementSibling?.classList.remove("d-none");
        target.querySelector(".plus").classList.add("d-none");
          target.querySelector(".minus").classList.remove("d-none");
      } else {
        target.nextElementSibling?.classList.add("d-none");
         target.querySelector(".plus").classList.remove("d-none");
          target.querySelector(".minus").classList.add("d-none");
      }
    },
    closeIt: function(){
      if(this.$route.fullPath.includes('refined')){
        this.$router.push({ path: `/` });
      }
      this.$emit("close");
    },
    expand: function(event){

       if(event.target.tagName == "INPUT"){
         return false;
       }
      let { target } = event;
        while(!target.classList.contains("title")){
                target = target.parentNode;
        }
        if(target.nextElementSibling?.classList.contains("d-none")){
          target.nextElementSibling?.classList.remove("d-none");
          target.querySelector(".plus").classList.add("d-none");
          target.querySelector(".minus").classList.remove("d-none");
        } else {
          target.querySelector(".plus").classList.remove("d-none");
          target.querySelector(".minus").classList.add("d-none");
          target.nextElementSibling?.classList.add("d-none");
        }    
    },
    apply: function(){
      let self = this;
      if(self.contentList.length > 0){       
        if(!this.$route.fullPath.includes('refined')){
            this.$router.push({ path: `/?refined` });
        }
        
        let refinedItem =  self.contentList;
        self.contentList.forEach(elem => {
             if(elem.subDocuments != null){
               let ids= elem.subDocuments.map(x=>x.id);
               refinedItem = refinedItem.filter(x=> !ids.includes(x.id));
             }
        });

        let parts = [...new Set(refinedItem.map(item => item.partID))];       
        let constructedItems = []; 

        parts.forEach(p=>{
          const original_part_object = self.getAllByLaws.parts.find(x=>x.id==p);
          const partContent = original_part_object.children;

          let part_item = JSON.parse(JSON.stringify(original_part_object));
          part_item.children = [];
          let partContentInFilter = refinedItem.filter(x=>x.partID==p);
          let parents = [...new Set(partContentInFilter.map(item => item.parentID))];
          let notIncludedParents = parents.filter(x => !partContentInFilter.includes(x.id));

          for(let i = 0; i < notIncludedParents.length; i++){
            let list_of_content = JSON.parse(JSON.stringify(partContent));
            let parentContent = this.searchContent(list_of_content, notIncludedParents[i]);
            if(parentContent != null) {
               parentContent.subDocuments = partContentInFilter.filter(x=>x.parentID == parentContent.id);
               parentContent.subDocuments = parentContent.subDocuments.sort(function (a, b) {            
                 return VersionCompare.Comparer(a.version, b.version);
               });
               part_item.children.push(parentContent);
            }           
          }
          
          part_item.children = part_item.children.sort(function (a, b) {            
            return VersionCompare.Comparer(a.version, b.version);
          });
         
          constructedItems.push(part_item);
        });

        constructedItems = constructedItems.sort(function (a, b) {
          return a.order - b.order;
        });

        self.$emit("applyFilter",constructedItems);
      }
      
    },
    searchContent: function(list, id){  
         let iterator = 0; 
         while(list.length > iterator) { 
            const stack = [ list[iterator++] ];
            while (stack.length) {
              const content = stack.pop();
              if (content.id === id) {return content;}
              content.subDocuments && stack.push(...content.subDocuments)
            }
         }
     
        return null;
    }
  },
   watch: {    
    getAllByLaws: function (newvalue) {
      if(newvalue){
        this.contentList = newvalue;
      }
    },
   
  }
};
</script>